import { render } from "./sitemap-breadcrumb.vue?vue&type=template&id=68916e6a"
import script from "./sitemap-breadcrumb.js?vue&type=script&lang=js"
export * from "./sitemap-breadcrumb.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__